import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import api from '../services/api';

// Create context
const AppContext = createContext();

// Context provider component
export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedTopic, setSelectedTopic] = useState('');
  const [countries, setCountries] = useState([]);
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Login function
  const login = async (username, password) => {
    try {
      setLoading(true);
      const response = await api.login(username, password);
      setUser(response.user);
      setLoading(false);
      return true;
    } catch (err) {
      setError(err.message);
      setLoading(false);
      return false;
    }
  };

  // Logout function
  const logout = () => {
    setUser(null);
    localStorage.removeItem('jwt');
  };

  // Clear any errors
  const clearError = () => {
    setError(null);
  };

  // Change password function
  const changePassword = async (currentPassword, newPassword, confirmPassword) => {
    try {
      setLoading(true);
      const response = await api.changePassword(currentPassword, newPassword, confirmPassword);
      setUser(response.user);
      setLoading(false);
      return true;
    } catch (err) {
      setError(err.message);
      setLoading(false);
      return false;
    }
  };

  const fetchCountries = async () => {
    try {
      const data = await api.getCountries();
      setCountries(data);
    } catch (err) {
      setError(err.message);
    }
  };

  const fetchTopics = async () => {
    try {
      const data = await api.getTopics();
      setTopics(data);
    } catch (err) {
      setError(err.message);
    }
  };

  // Context value
  const value = {
    user,
    selectedCountry,
    selectedTopic,
    countries,
    topics,
    loading,
    error,
    setSelectedCountry,
    setSelectedTopic,
    login,
    logout,
    clearError,
    changePassword,
    fetchCountries,
    fetchTopics,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

// Custom hook to use the context
export const useApp = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};

export default AppContext;
